import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

import $ from 'jquery';

import { throttle, isUndefined } from 'lodash';
import browser from 'detect-browser';

import contextTypes from './ContextTypes';

// TODO: fix these files
/* eslint-disable no-underscore-dangle, react/no-find-dom-node */

export default function TableMixinComponent({ displayName, render }) {
    return class TableMixin extends Component {
        static displayName = displayName;

        static propTypes = {
            setContextHelper: PropTypes.func.isRequired,
            isScrollbarVisible: PropTypes.bool,
        };

        static contextTypes = contextTypes;

        static defaultProps = {
            isScrollbarVisible: false,
        };

        constructor(props) {
            super(props);

            this._isDelegatedScroll = false;
            this._tableHeight = 0;
            this._latestDelegatedScrollPosition = 0;
            this._delegateTableScroll = this._delegateTableScroll.bind(this);
            this._verticalScrollBarScrolling = this._verticalScrollBarScrolling.bind(this);

            props.setContextHelper({
                onScrollbarScroll: this._verticalScrollBarScrolling,
            });
        }

        componentDidMount() {
            const { setTableView, setScrollbarVisibility } = this.context;

            const DOMNode = this._getDOMNode();
            setScrollbarVisibility();

            setTableView(DOMNode);
            DOMNode.addEventListener('scroll', this._delegateTableScroll);
            this._setScrollbarVisibility = throttle(setScrollbarVisibility, 100);
        }

        componentDidUpdate() {
            const DOMNode = this._getDOMNode();

            if (DOMNode) {
                const { onTableChange } = this.context;
                const newTableHeight = this._getDOMTableHeight();

                if (this._tableHeight !== newTableHeight) {
                    this._setTableHeight();
                    onTableChange();
                    this._setScrollbarVisibility();
                    this._setTableRightPosition();
                }
            }
        }

        componentWillUnmount() {
            const DOMNode = this._getDOMNode();
            if (DOMNode) {
                DOMNode.removeEventListener('scroll', this._delegateTableScroll);
            }
        }

        _getDOMNode() {
            return $(findDOMNode(this))
                .find('table')
                .closest('div')[0];
        }

        _delegateTableScroll() {
            function _calculatePosition({ myHeight, newPosition, tableHeight }) {
                const heightDifference = Math.max(tableHeight - myHeight, 1);
                const result = Number((newPosition / heightDifference).toFixed(5));
                return Math.max(0, Math.min(1, result));
            }

            const DOMNode = this._getDOMNode();

            if (this._isDelegatedScroll) {
                const { scrollHeight: _newTableHeight } = $(DOMNode).find('table')[0];

                if (this._tableHeight !== _newTableHeight) {
                    this._tableHeight = _newTableHeight;
                    this._verticalScrollBarScrolling();
                }
                this._isDelegatedScroll = false;
            } else {
                const { onTableScroll } = this.context;
                const newPosition = DOMNode.scrollTop;
                const { scrollHeight: tableHeight } = $(DOMNode).find('table')[0];
                const myHeight = $(DOMNode).height();

                const newPositionInPercent = _calculatePosition({
                    newPosition,
                    tableHeight,
                    myHeight,
                });

                this._latestDelegatedScrollPosition = newPositionInPercent;
                onTableScroll(newPositionInPercent);
            }
        }

        _setTableHeight() {
            this._tableHeight = this._getDOMTableHeight();
        }

        _getDOMTableHeight() {
            return $(findDOMNode(this)).find('table')[0].scrollHeight;
        }

        _setTableRightPosition() {
            const fixedBrowser = browser || { name: '' };

            if (this.props.isScrollbarVisible) {
                $(findDOMNode(this)).addClass(`${fixedBrowser.name}-type`);
            }
        }

        _verticalScrollBarScrolling(valueInPercent = this._latestDelegatedScrollPosition) {
            let newValueInPercent = valueInPercent;

            const DOMNode = this._getDOMNode();

            if (isUndefined(this._tableHeight) || !this.tableHeight) {
                this._setTableHeight();
            }

            this._latestDelegatedScrollPosition = valueInPercent;
            this._isDelegatedScroll = true;
            if (parseInt(valueInPercent, 10) === 1) {
                newValueInPercent = 1.1;
            }

            DOMNode.scrollTop = (this._tableHeight - $(DOMNode).height()) * newValueInPercent;
        }

        render() {
            return render(this.props);
        }
    };
}
